import React, { Component, Fragment } from 'react';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaHttpClientInvoice } from '../../../code/ArcaHttpClientInvoice';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { InputField } from '../Fields/InputField';
import { StatusBar } from '../StatusBar';
import { InvoiceListPanel } from './InvoiceListPanel';
import { ArcaLink } from '../Fields/ArcaLink';
import { FaFileInvoice } from 'react-icons/fa';

export class InvoiceListByTypePanel extends Component {

    selectedStatus = 'Invoiced'

    constructor(props) {
        super(props);

        var formState = this.buildFields(this.selectedStatus);

        this.state = {
            formState: formState,
            fields: formState.Fields,

            invoices: null,
            message: null,
            isError: false,
            status: this.selectedStatus
        };
    }

    componentDidMount() {
        this.getDetails(this.selectedStatus)
    }

    getDetails(status) {
        this.selectedStatus = status
        ArcaHttpClientInvoice.GetListByStatus(
            status,
            (invoices => this.setState({ invoices })),
            (() => this.setState({
                isError: false, message: `No invoices of status '${status}'found!`
            })),
            ((msg) => this.setState({
                isError: true, message: msg
            }))
        )
    }

    async onUpdate(value, isValid, fieldName) {

        this.state.formState.GetField(fieldName).Value = value

        this.selectedStatus = value
        this.getDetails(value)
    }


    render() {
        let { invoices, message, isError } = this.state;
        let createAllInvoices = () => {
            ArcaHttpClientInvoice.CreateAllInvoices(
                (() => this.getDetails('Created')),
                ((message) => this.setState({ message, isError: true }))
            );
        }

        return (
            <Fragment>
                <h1 className='centerText'>Invoices</h1>

                <StatusBar message={message} isError={isError} />

                {this.state.fields.map((f, k) =>
                    <InputField
                        label={f.FieldLabel}
                        fieldname={f.FieldName}
                        key={f.FieldName}
                        regularExpression={f.Validation}
                        warnText='Invalid format'
                        fieldType={f.FieldType}
                        mandatory={f.IsMandatory}
                        value={f.Value}
                        onUpdate={this.onUpdate.bind(this)}
                        fieldValid={f.IsValid}
                        prependWidth={'200px'}
                        description={f.Description}
                        inline={true}
                    />)}

                <ArcaLink icon={<FaFileInvoice size='30px' />} text='Create all new Invoices' colour='primary' width='100%' onClick={createAllInvoices} />

                {invoices
                    ? <InvoiceListPanel invoices={invoices} onUpdated={() => this.getDetails(this.selectedStatus)} />
                    : null}

            </Fragment>
        );
    }

    buildFields(status) {

        var formState = new ArcaPageFieldState();

        formState.AddField(new ArcaField("Invoice status", "InvoiceStatus", status, true, true, 'select', 'InvoiceStatusType'));

        return formState;
    }
}